// Table of contents:
// Additional Data
// Additional Documents
// Summary
import { EInvoice } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createEInvoice = (): EInvoice => {
  return {
    // Additional Data
    additionalData: {
      client: {
        buyerEmail: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.client.form.buyerEmail.label',
          ), // t('eInvoiceDetails.stepper.additionalData.client.form.buyerEmail.label')
          options: [],
        },
        buyerName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.client.form.buyerName.label',
          ), // t('eInvoiceDetails.stepper.additionalData.client.form.buyerName.label')
        },
        buyerRoutingId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.client.form.buyerRoutingId.label',
          ), // t('eInvoiceDetails.stepper.additionalData.client.form.buyerRoutingId.label')
        },
        buyerPhone: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.client.form.buyerPhone.label',
          ), // t('eInvoiceDetails.stepper.additionalData.client.form.buyerPhone.label')
        },
      },
      invoiceReferences: {
        projectNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.projectNumber.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.projectNumber.label')
        },
        contractNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.contractNumber.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.contractNumber.label')
        },
        orderNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.orderNumber.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.orderNumber.label')
        },
        workOrderNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.workOrderNumber.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.workOrderNumber.label')
        },
        goodsReceiptNotification: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.goodsReceiptNotification.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.goodsReceiptNotification.label')
        },
        shippingNotification: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.shippingNotification.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.shippingNotification.label')
        },
        tender: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.tender.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.tender.label')
        },
        objectReference: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.objectReference.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.objectReference.label')
        },
        bookingAccount: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.invoiceReferences.form.bookingAccount.label',
          ), // t('eInvoiceDetails.stepper.additionalData.invoiceReferences.form.bookingAccount.label')
        },
      },
      invoiceLines: {
        table: {
          enabled: true,
          columns: [
            {
              enabled: true,
              field: 'ID.Value.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.position.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.position.header')
            },
            {
              enabled: true,
              field: 'OrderLineReference.LineID.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.orderPosition.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.orderPosition.header')
            },
            {
              enabled: true,
              field: 'Item.SellersItemIdentification.ID.Value.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.articleNumber.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.articleNumber.header')
            },
            {
              enabled: true,
              field: 'Item.BuyersItemIdentification.ID.Value.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.buyerArticleNumber.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.buyerArticleNumber.header')
            },
            {
              enabled: true,
              field: 'Item.Name.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.nameAndDescription.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.nameAndDescription.header')
            },
            {
              enabled: true,
              field: 'InvoicedQuantity.Value.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.quantity.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.quantity.header')
            },
            {
              enabled: true,
              field: 'LineExtensionAmount.Value.Value',
              header: getTranslationsForConfig(
                'eInvoiceDetails.stepper.additionalData.positions.table.columns.totalNet.header',
              ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.totalNet.header')
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.positions.table.emptyMessageDetails',
          ), // t('eInvoiceDetails.stepper.additionalData.positions.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.positions.table.emptyMessageTitle',
          ), // t('eInvoiceDetails.stepper.additionalData.positions.table.emptyMessageTitle')
          paginator: true,
          rows: 20,
          rowsPerPageOptions: [20, 50, 100],
          sortField: 'ID.Value.Value',
          sortOrder: 1,
        },
        lineId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.positions.table.columns.position.header',
          ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.position.header')
        },
        buyersItemId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.positions.table.columns.buyerArticleNumber.header',
          ), // t('eInvoiceDetails.stepper.additionalData.positions.table.columns.buyerArticleNumber.header')
        },
      },
      remarks: {
        additionalRemarks: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.additionalData.remarks.form.additionalRemarks.label',
          ), // t('eInvoiceDetails.stepper.additionalData.remarks.form.additionalRemarks.label')
        },
      },
    },
    // Additional Documents
    additionalDocuments: {
      attachment: {
        enabled: true,
        label: getTranslationsForConfig(
          'eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.form.attachment.label',
        ), // t('eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.form.attachment.label')
      },
      description: {
        enabled: true,
        label: getTranslationsForConfig(
          'eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.form.description.label',
        ), // t('eInvoiceDetails.stepper.additionalDocuments.table.upload.dialog.form.description.label')
      },
    },
    // Summary
    summary: {
      invoiceOverview: {
        invoiceNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceNumber.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceNumber.label')
        },
        invoiceType: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceType.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceType.label')
        },
        invoiceDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceDate.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceDate.label')
        },
        deliveryDate: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.deliveryDate.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.deliveryDate.label')
        },
        totalAmountGross: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.totalAmountGross.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.totalAmountGross.label')
        },
        invoiceClassification: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceClassification.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceOverview.form.invoiceClassification.label')
        },
      },
      invoiceRecipient: {
        customerId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerId.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerId.label')
        },
        customerName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerName.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerName.label')
        },
        customerPartyName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerPartyName.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerPartyName.label')
        },
        customerCompanyId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCompanyId.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCompanyId.label')
        },
        customerStreet: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerStreet.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerStreet.label')
        },
        customerPostalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerPostalCode.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerPostalCode.label')
        },
        customerCity: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCity.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCity.label')
        },
        customerCountry: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCountry.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.customerCountry.label')
        },
        foundCompanyCodeMasterData: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.invoiceRecipient.form.foundCompanyCodeMasterData.label',
          ), // t('eInvoiceDetails.stepper.summary.invoiceRecipient.form.foundCompanyCodeMasterData.label')
        },
      },
      invoiceIssuer: {
        sellerId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerId.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerId.label')
        },
        sellerRegistrationName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerRegistrationName.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerRegistrationName.label')
        },
        sellerName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerName.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerName.label')
        },
        sellerCompanyId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerCompanyId.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerCompanyId.label')
        },
        sellerStreet: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerStreet.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerStreet.label')
        },
        sellerPostalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerPostalCode.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerPostalCode.label')
        },
        sellerCity: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerCity.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerCity.label')
        },
        sellerCountry: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.sellerCountry.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.sellerCountry.label')
        },
        foundSupplierMasterData: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.biller.form.foundSupplierMasterData.label',
          ), // t('eInvoiceDetails.stepper.summary.biller.form.foundSupplierMasterData.label')
        },
      },
      client: {
        buyerEmail: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerEmail.label',
          ), // t('eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerEmail.label')
        },
        buyerName: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerName.label',
          ), // t('eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerName.label')
        },
        buyerRoutingId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerRoutingId.label',
          ), // t('eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerRoutingId.label')
        },
        buyerPhone: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerPhone.label',
          ), // t('eInvoiceDetails.stepper.summary.accountingCustomer.form.buyerPhone.label')
        },
      },
      invoiceReferences: {
        projectId: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.projectId.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.projectId.label')
        },
        contractNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.contractNumber.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.contractNumber.label')
        },
        orderNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.orderNumber.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.orderNumber.label')
        },
        salesOrderNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.salesOrderNumber.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.salesOrderNumber.label')
        },
        receiptDocument: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.receiptDocument.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.receiptDocument.label')
        },
        despatchDocument: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.despatchDocument.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.despatchDocument.label')
        },
        originatorDocument: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.originatorDocument.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.originatorDocument.label')
        },
        objectReference: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.objectReference.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.objectReference.label')
        },
        accountingCost: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.references.form.accountingCost.label',
          ), // t('eInvoiceDetails.stepper.summary.references.form.accountingCost.label')
        },
      },
      remarks: {
        additionalRemarks: {
          enabled: true,
          label: getTranslationsForConfig(
            'eInvoiceDetails.stepper.summary.remarks.form.additionalRemarks.label',
          ), // t('eInvoiceDetails.stepper.summary.remarks.form.additionalRemarks.label')
        },
      },
    },
  }
}
